// @flow
import { createStore, applyMiddleware, compose } from "redux";
// flow-disable-next-line
import { createLogger } from "redux-logger";
import thunk from "redux-thunk";
import rootReducer from "./rootReducer";

const middleware = applyMiddleware(thunk, createLogger());

const getStore = (isClient: boolean) =>
  isClient
    ? createStore(
        rootReducer,
        window.INITIAL_STATE,
        compose(
          middleware,
          window.devToolsExtension ? window.devToolsExtension() : f => f
        )
      )
    : createStore(
        rootReducer,
        compose(
          middleware,
          window.devToolsExtension ? window.devToolsExtension() : f => f
        )
      );

export default getStore;



// WEBPACK FOOTER //
// ./app/main/store.js